/**
 * @file Morph Intro.
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Morph intro.
 */
const morphIntro = () => {
	const intro = document.querySelector('.v-morph-intro');
	if (!intro) return;

	gsap.registerPlugin(ScrollTrigger);

	const content = intro.querySelector('.v-morph-intro__content');
	const header = document.querySelector('.v-header');

	const introTl = gsap.timeline({
		scrollTrigger: {
			trigger: header,
			start:   'bottom top',
			end:     '+=300px',
			scrub:   true,
		},
		defaults: { duration: 1 },
	});
	introTl
		.to(content, {
			translateY: -500,
		});
};

export default morphIntro;
